export default "__VITE_ASSET__BmphM5IL__"